import { cn } from "@/lib/utils"

const gridTemplate = "120px minmax(0,1fr) 400px 200px 18.25rem"

type NewsGridProps = React.HTMLAttributes<HTMLDivElement> & { ref?: React.Ref<HTMLDivElement> }
export const NewsGrid = ({ className, children, ...props }: NewsGridProps) => (
  <div className={cn("grid", className)} style={{ gridTemplateColumns: gridTemplate }} {...props}>
    {children}
  </div>
)
